<div class="organized-background">
  <div class="container casestudies-body">
    <div class="row">
      <div class="col-md-6 py-5">
        <p class="text-white link-casestudy"><span (click)="nav('/')">Home</span> / <span (click)="nav('/kalpita-case-studies/case-study')">Case Studies</span></p>
        <h1 class="py-3 organized-heading">
          Organized eCommerce portal with 3 roles of managed access and payment
          gateways.
        </h1>
        <p class="py-3 organized-para">
          Our in-house team developed an online retail ecommerce platform for a
          Chilean company, providing the client with three levels of access to
          the platform as well as a payment gateway for easy payments.
        </p>
        <div class="service-industry py-3">
          <div class="industry-box">
            <h6>Industry:<span class="retail">Retail</span></h6>
          </div>
          <div class="service-box">
            <h6>Service:<span>Mobile Application Development</span></h6>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <img
          src="../../../../assets/industry/casestudies/organized-computerEcommerce.png"
          class="img-fluid organized-computer" alt="orgimg"
        />
      </div>
    </div>
  </div>
</div>
<!-- Firebase crashlytics were integrated to prioritise key app crashes and their impact on real-time users. -->
<div class="container">
  <div class="row">
    <p class="py-5">
      Firebase crashlytics were integrated to prioritise key app crashes and
      their impact on real-time users.
    </p>
    <div class="col-md-6 py-1">
      <ul>
        <li class="ico-img">Admin, Seller, Customer</li>
        <li class="ico-img">User friendly payment options (F-Pay)</li>
      </ul>
    </div>
    <div class="col-md-6 py-1">
      <ul>
        <li class="ico-img">Admin, Seller, Customer</li>
        <li class="ico-img">User friendly payment options (F-Pay)</li>
      </ul>
    </div>
    <div class="d-flex justify-content-center">
      <img
        src="../../../../assets/resources/casestudies/triangleimg.svg"
        alt="taiangle-icon"
      />
    </div>
  </div>
</div>
<!-- The challenge......................................................................... -->
<div class="challenge-background">
  <div class="container py-3">
    <div class="row">
      <div class="col-md-6">
        <h5 class="challenge-head py-3">The challenge</h5>
        <p class ="challenge_para">
          As the client business spanned over 3 different countries, they needed
          different interface based on country selection to address end
          customers with relevant products and offers.
        </p>
      </div>

      <div class="col-md-6">
        <h5 class="challenge-head py-3">Solution</h5>
        <p class ="challenge_para">
          Our Mobile app interface was designed such that end users could switch
          internally(in-app), by choosing their location to view most relevant
          location-based products and offers. While maintaining a consistent web
          front across countries.
        </p>
      </div>
    </div>
  </div>
</div>
<!-- Geography.................................................................................... -->
<div class="container">
  <div class="row py-3">
    <div class="col-md-12">
      <h5 class="challenge-head py-3">Geography</h5>
      <div class="row">
        <div class="col-md-3 col-6 py-2 text-center">
          <img
            src="../../../../assets/resources/casestudies/chile-flag.png"
            alt="flag-one"
            class="flags"
          />
          <p class="pt-1">Chile</p>
        </div>
        <div class="col-md-3 col-6 py-2 text-center">
          <img
            src="../../../../assets/resources/casestudies/peru-flag.png"
            alt="flag-two"
            class="flags"
          />
          <p class="pt-1">Peru</p>
        </div>
        <div class="col-md-3 col-6 py-2 text-center">
          <img
            src="../../../../assets/resources/casestudies/Colombia_flag.png"
            alt="flag-three"
            class="flags"
          />
          <p class="pt-1">Colombia</p>
        </div>
        <div class="col-md-3 col-6 py-2 text-center">
          <img
            src="../../../../assets/resources/casestudies/argentina-flag.png"
            alt="flag-four"
            class="flags"
          />
          <p class="pt-1">Argentina</p>
        </div>
      </div>

      <h5 class="challenge-head py-3">Language</h5>
      <p>Spanish</p>
    </div>

   
  </div>
</div>
<!-- Technologies used......................................................... -->
<div class="container">
  <div class="row py-3">
    <div class="col-md-8">
      <h5 class="challenge-head py-3">Technologies used</h5>
      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-2 col-6 py-2">
          <img
            src="../../../../assets/resources/casestudies/icons/swift-tech.png"
            class="img-fluid tech-icon" alt="tecimgone"
          />
        </div>
        <div class="col-md-2 col-6 py-2">
          <img
            src="../../../../assets/resources/casestudies/icons/flash-tech.png"
            class="img-fluid tech-icon" alt="tecimgtwo"
          />
        </div>
        <div class="col-md-2 col-6 py-2">
          <img
            src="../../../../assets/resources/casestudies/icons/firebase-tech.png"
            class="img-fluid tech-icon" alt="tecimgthree"
          />
        </div>
      </div>
    </div>
    <div class="col-md-4"></div>
  </div>
</div>
